import * as actions from './CurrentUserActions';
import { toast } from 'react-toastify';

export const CurrentUserMiddleware = store => next => action => {
  const result = next(action);

  switch (action.type) {
    case actions.CURRENT_USER_LOG_OUT:
      if (action.msg) {
        setTimeout(() => toast.info(action.msg), 0); // TODO: move this to redux action
      }
      break;
    default:
      break;
  }

  return result
};



// WEBPACK FOOTER //
// ./src/store/current-user/CurrentUserMiddleware.js